"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableGroupAggCell = void 0;
const AnswerFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/AnswerFieldType/AnswerFieldType"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey/ViewFieldKey"));
const Flag_1 = __importStar(require("@opsbase/lib-issue/Flag/Flag"));
const Pill_1 = __importDefault(require("@opsbase/web-chips/Pill/Pill"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree/useDataTree"));
const Rating_1 = __importDefault(require("@opsbase/web-ui/Rating/Rating"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text/Text"));
const react_1 = __importStar(require("react"));
const ScoreChip_1 = __importDefault(require("../../chips/ScoreChip/ScoreChip"));
const DVLTableCell_1 = __importDefault(require("../DVLTableCell/DVLTableCell"));
const calcAggValue_1 = __importDefault(require("../helpers/calcAggValue"));
function numToStr(num) {
    if (!num)
        return '';
    return (Math.round(num * 100) / 100).toString();
}
function DVLTableGroupAggCell(props) {
    const dt = (0, useDataTree_1.default)();
    const { nodeKey, field, colIdx, isLastCol } = props;
    const isFirstCol = colIdx === 0;
    const node = dt.nodesByKey.get(nodeKey);
    const aggs = dt.aggsForNode.get(node);
    const value = (0, calcAggValue_1.default)(aggs, field);
    const { width, fieldType, key: viewFieldKey, aggFlag, aggLabel } = field;
    const innards = (0, react_1.useMemo)(() => {
        if (value === undefined)
            return null;
        if (viewFieldKey === ViewFieldKey_1.default.QUESTIONANSWER) {
            switch (fieldType) {
                case AnswerFieldType_1.default.ANSWER_NUMBER:
                    return react_1.default.createElement(Text_1.default, null, numToStr(value));
                case AnswerFieldType_1.default.ANSWER_CHECK:
                    return (react_1.default.createElement(Pill_1.default, { value: Math.floor(value * 100) + '%', label: aggLabel, color: (0, Flag_1.flagColor)(aggFlag || Flag_1.default.GREEN) }));
                case AnswerFieldType_1.default.ANSWER_RATING:
                    return react_1.default.createElement(Rating_1.default, { value: value });
            }
        }
        if (viewFieldKey === ViewFieldKey_1.default.OP_SCORE && value !== null)
            return react_1.default.createElement(ScoreChip_1.default, { scoreMax: 100, scoreTotal: value });
        return null;
    }, [aggLabel, aggFlag, fieldType, viewFieldKey, value]);
    return (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(DVLTableCell_1.default, { alignItems: "flex-end", width: width, key: 'item_' + colIdx, isFirstCol: isFirstCol, isLastCol: isLastCol, padded: true }, innards));
    }, [colIdx, width, innards, isFirstCol, isLastCol]);
}
exports.DVLTableGroupAggCell = DVLTableGroupAggCell;
exports.default = DVLTableGroupAggCell;
